import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('backend') + '/api/v1/ocr/region/read';

export const readRegion = async (img, region) => {
  return axios
    .post(
      endPoint,
      {
        image: img,
        region: region,
      },
      {
        timeout: 30000,
      },
    )
    .then((res) => res.data)
    .catch(() => '');
};

export const readRegionV2 = async (img, region) => {
  return axios
    .post(
      endPoint + '/multiple',
      {
        image: img,
        region: region,
      },
      {
        timeout: 30000,
      },
    )
    .then((res) => res.data)
    .catch(() => '');
};
